import React from 'react';
import { Flex } from 'antd';
import { PatientInfo } from 'lib/api/firebase/apis/apis';
import { AssessmentType } from 'lib/documents/patient-assessment/patient-assessment';
import { AssessmentBalanceAlerts } from '../../../../schedule-test/_components/assessment-balance-alerts';
import { ProgressTableRow } from '../types';
import { PatientListProgressTable } from './PatientListProgressTable';

interface ConfirmationStateProps {
  assessmentTypeToSend: AssessmentType | null;
  eligiblePatients: PatientInfo[];
  allPatients: PatientInfo[];
  progressRows: ProgressTableRow[];
}

export function ConfirmationState(props: ConfirmationStateProps) {
  return (
    <Flex vertical gap="middle" style={{ marginTop: 16 }}>
      <AssessmentBalanceAlerts assessmentType={props.assessmentTypeToSend ?? undefined} />

      <p>
        <strong>Selected Test-Takers:</strong>
      </p>
      
      <PatientListProgressTable
        rows={props.progressRows}
        showStatus={false}
      />

      {props.eligiblePatients.length > 0 ? (
        <p>
          Are you sure you want to send a <strong>{props.assessmentTypeToSend}</strong> assessment to{' '}
          <strong>{props.eligiblePatients.length}</strong> selected test-taker(s)?
        </p>
      ) : (
        <p>
          Are you sure you want to re-send the assessment email to the <strong>{props.allPatients.length}</strong> selected test-taker(s)?
        </p>
      )}
    </Flex>
  );
}
